import { Modal, Typography } from 'antd'
import { EXPLORER_GRAY } from 'features/drilldown'
import { Minimize2 } from 'lucide-react'
import React, { ReactNode } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

const { Text } = Typography

const DEFAULT_ICON_COLOR = CantileverTheme.colors.slate['400']

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const IconWrapper = styled.span`
  color: ${DEFAULT_ICON_COLOR};
`

const ContentContainer = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
`

interface FullscreenModalProps {
  open: boolean
  onClose: () => void
  title: string
  icon?: ReactNode
  children: ReactNode
}

export const FullscreenModal: React.FC<FullscreenModalProps> = ({
  open,
  onClose,
  title,
  icon,
  children,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      closeIcon={<Minimize2 size={16} />}
      footer={null}
      centered
      width='calc(100vw - 30px)'
      style={{
        padding: 0,
        maxWidth: 'calc(100vw - 30px)',
      }}
      styles={{
        container: {
          background: EXPLORER_GRAY,
        },
        body: {
          height: 'calc(100vh - 70px)',
        },
      }}
      destroyOnHidden={true}
      closable={true}
      maskClosable={true}>
      <HeaderContainer>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <Text strong>{title}</Text>
      </HeaderContainer>

      <ContentContainer>{children}</ContentContainer>
    </Modal>
  )
}
